import Navbar from "./components/NavBar";
import Footer from "./components/Footer";
import Apply from "./components/Apply";

const Layout = ({ children }) => {
    return (
        <>
            <header>
                <Navbar />
                <Apply />
            </header>
            <main>
                {children}
            </main>
            <footer>
                <Footer />
            </footer>

        </>
    );
}

export default Layout;